import Dropzone from "dropzone";

export default class FileUploader {

	constructor() {

		var $this = this;

		var fileUploaders = document.getElementsByClassName("js-file-uploader");

		for (var i = 0; i < fileUploaders.length; i++) {
			$this.fileUploader(fileUploaders.item(i));
		}

	}

	fileUploader(item) {

		var $this = this;

		var dropZone = new Dropzone(item, {
			url: item.getAttribute('action'),
			maxFilesize: 20, // MB
			timeout: 120000,
			init: function() {
				this.on("sending", function(file, xhr, formData) {
					formData.append("_token", $('meta[name="csrf-token"]').attr("content"));
				});
				this.on("success", function(file, response) {
					this.removeFile(file);

					$this.maybeRefreshElement(response);
				});
				this.on('error', function(file, response) {
					$this.autoClose = false;
					if (!response.errors) {
				        if (response.message) {
				            new Flash.error(response.message);
				        }
						return;
					}
					Object.keys(response.errors).forEach(function (item) {
						Object.keys(response.errors[item]).forEach(function (subItem) {
							new Flash.error(response.errors[item][subItem]);
						});
					});
				});
			}
		});

	}

	maybeRefreshElement(response) {

		var refresh = response.refresh;

		if (typeof refresh == "undefined") {
			return;
		}

		if (typeof refresh.target == "undefined") {

			var $this = this;

			refresh.forEach(function(item) {
				$this.refreshElement(item);
			});

			return;
		}

		this.refreshElement(refresh);

	}

	refreshElement(refresh) {

		$(refresh.target).html(refresh.view);

	}

}